import { useMainContext } from "../../../../context";
import {
  verifyCreditCard,
  verifyDebitCards,
} from "../../../../utils/checkAcceptCard";
import { useCartContext } from "../../context";

import AleloCard from "../../../../assets/icons/credit_cards/AleloCard.png";
import AmericanCard from "../../../../assets/icons/credit_cards/AmericanCard.png";
import DinnersCard from "../../../../assets/icons/credit_cards/DinnersCard.png";
import EloCard from "../../../../assets/icons/credit_cards/EloCard.png";
import HiperCard from "../../../../assets/icons/credit_cards/HiperCard.png";
import MaestroCard from "../../../../assets/icons/credit_cards/MaestroCard.png";
import MasterCard from "../../../../assets/icons/credit_cards/MasterCard.png";
import VisaCard from "../../../../assets/icons/credit_cards/VisaCard.png";
import { IoCard, IoCash, IoCopyOutline, IoQrCode } from "react-icons/io5";
import { useCallback, useMemo } from "react";
import InputLabel from "../../../../components/inputLabel";

const cardFlags = [
  { id: "visa", name: "Visa", image: VisaCard },
  { id: "mastercard", name: "Mastercard", image: MasterCard },
  { id: "elo", name: "Elo", image: EloCard },
  { id: "hiper", name: "Hiper", image: HiperCard },
  { id: "dinners", name: "Dinners", image: DinnersCard },
  { id: "american_express", name: "Amex", image: AmericanCard },
  { id: "alelo", name: "Alelo", image: AleloCard },
  { id: "maestro", name: "Maestro", image: MaestroCard },
];

const CartPaymentMethods = () => {
  const {
    changePayMethod,
    changeCardFlag,
    verifyCard,
    thing,
    changeThing,
    copyToClipboard,
  } = useCartContext();
  const { restaurant, order } = useMainContext();

  const selectedPaymentMethod = useMemo(() => order?.payment_mode, [order]);

  const selectedCardFlag = useMemo(() => order?.card_flag, [order]);

  const avaiableCardFlags = useMemo(() => {
    if (
      !restaurant ||
      !["credit_card", "debit_card"].includes(selectedPaymentMethod)
    )
      return [];

    return cardFlags.filter((flag) =>
      verifyCard(selectedPaymentMethod, flag.id),
    );
  }, [restaurant, verifyCard, selectedPaymentMethod]);

  const paymentMethodOptions = useMemo(
    () =>
      [
        {
          id: "cash",
          label: "Dinheiro",
          icon: IoCash,
          enabled: restaurant.settings.payment_cash,
        },
        {
          id: "pix",
          label: "Pix",
          icon: IoQrCode,
          enabled: restaurant.settings.payment_pix,
        },
        {
          id: "credit_card",
          label: "Cartão de crédito",
          icon: IoCard,
          enabled: verifyCreditCard(restaurant),
        },
        {
          id: "debit_card",
          label: "Cartão de débito",
          icon: IoCard,
          enabled: verifyDebitCards(restaurant),
        },
      ].filter((method) => method.enabled),
    [restaurant],
  );

  const handleCopyPixKey = useCallback(() => {
    const pixKey = restaurant.general_settings.default_pix_key || "";

    if (pixKey) {
      copyToClipboard(pixKey);
    }
  }, [restaurant]);

  const renderPaymentMethod = useCallback(
    (method) => {
      const Icon = method.icon;

      return (
        <label
          key={method.id}
          className={`cursor-pointer flex items-center p-4 rounded-lg border shadow hover:bg-gray-200 transition-colors ${selectedPaymentMethod === method.id ? "border-primary-500" : ""}`}
        >
          <div className="flex flex-grow justify-between">
            <div className="flex items-center gap-2">
              <Icon className="w-5 h-5 text-gray-500" />
              <span className="font-bold">{method.label}</span>
            </div>

            <input
              onChange={() =>
                selectedPaymentMethod !== method.id
                  ? changePayMethod(method.id)
                  : {}
              }
              checked={selectedPaymentMethod === method.id}
              type="radio"
              className="hidden peer"
            />

            <div className="w-5 h-5 mr-3 border-2 rounded-full border-gray-400 peer-checked:bg-primary-500 peer-checked:border-primary-500 flex items-center justify-center">
              <svg
                className="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                viewBox="0 0 24 24"
              >
                <path d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>
        </label>
      );
    },
    [selectedPaymentMethod, changePayMethod],
  );

  const renderCardFlagOption = useCallback(
    (brand) => {
      return (
        <button
          onClick={() => changeCardFlag(brand.id)}
          key={brand.id}
          className={`flex items-center user-select-none rounded p-2 border-2 gap-2 hover:bg-gray-200 hover:shadow transition-colors ${selectedCardFlag === brand.id ? "border-primary-500" : "border-gray-300"}`}
        >
          <img
            alt={brand.name}
            src={brand.image}
            className="w-16 h-10 px-2 py-1 border-2 rounded object-contain"
          />

          <span className="text-sm uppercase">{brand.name}</span>
        </button>
      );
    },
    [selectedCardFlag, changeCardFlag],
  );

  return (
    <div className="flex flex-1 flex-col border-2 border-gray-200 rounded-xl p-4 shadow-sm">
      <h4 className="font-bold text-lg mb-4 break-words">FORMA DE PAGAMENTO</h4>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {paymentMethodOptions.map(renderPaymentMethod)}
      </div>

      {["debit_card", "credit_card"].includes(selectedPaymentMethod) && (
        <>
          <h4 className="font-bold text-lg mb-4 break-words mt-6">
            SELECIONE UMA BANDEIRA
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
            {avaiableCardFlags.map(renderCardFlagOption)}
          </div>
        </>
      )}

      {["cash"].includes(selectedPaymentMethod) && (
        <InputLabel
          label="Troco para"
          placeholder="R$ 20"
          value={thing}
          containerClass="mt-6"
          onChange={(event) => changeThing(event.target.value)}
        />
      )}

      {["pix"].includes(selectedPaymentMethod) && (
        <div className="flex flex-col mt-6">
          <label
            className="text-gray-500 text-sm font-medium break-words"
            htmlFor="pix-code"
          >
            Chave PIX
          </label>

          <div className="flex flex-row gap-2">
            <input
              type="text"
              id="pix-code"
              readOnly
              placeholder="Nenhuma chave fornecida"
              onClick={handleCopyPixKey}
              value={restaurant.general_settings.default_pix_key}
              className="bg-gray-100 w-full p-2 border-2 border-gray-400 outline-none rounded-lg cursor-pointer"
            />

            <button
              onClick={handleCopyPixKey}
              className="hidden sm:flex flex-row items-center border-2 rounded-lg border-primary-700 bg-primary-100 text-primary-700 px-2"
            >
              <IoCopyOutline className="w-4 h-4 mr-2" />
              <span className="text-sm">COPIAR</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartPaymentMethods;
